import * as actionType from "./constants";
import { saveState } from "../../containers/localStorage";
import { SYNC_USER_SUCCESS } from "../../synchronization/constants";
import { UPDATE_USER_SUCCESS } from "../constants";
import * as phases from "../../utils/helpers/phases";
const initialState = {
  phase: phases.INIT,
  user: undefined
};
export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.CHANGE_PASSWORD_REQUEST:
    case actionType.FORGOT_PASSWORD_REQUEST:
    case actionType.RESET_PASSWORD_REQUEST:
    case actionType.CONFIRM_EMAIL_REQUEST:
    case actionType.REGISTER_REQUEST:
    case actionType.LOGIN_REQUEST:
      return {
        ...state,
        phase: phases.LOADING
      };
    case actionType.LOGIN_SUCCESS:
      return {
        ...state,
        phase: phases.LOADED,
        user: action.payload
      };

    case actionType.CHANGE_PASSWORD_REJECT:
    case actionType.FORGOT_PASSWORD_REJECT:
    case actionType.RESET_PASSWORD_REJECT:
    case actionType.LOGIN_REJECT:
    case actionType.REGISTER_REJECT:
    case actionType.CONFIRM_EMAIL_REJECT:
      return {
        ...state,
        phase: phases.ERROR
      };
    case actionType.CHANGE_PASSWORD_SUCCESS:
    case actionType.FORGOT_PASSWORD_SUCCESS:
    case actionType.RESET_PASSWORD_SUCCESS:
    case actionType.CONFIRM_EMAIL_SUCCESS:
    case actionType.REGISTER_SUCCESS:
      return {
        ...state,
        phase: phases.LOADED
      };
    case SYNC_USER_SUCCESS: {
      if (action.user) {
        saveState("account", action.user);
        return {
          ...state,
          user: action.user
        };
      }
      return state;
    }
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        user:
          action.user.userId === state.user.userId ? action.user : state.user
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/users/loggedUser/reducer.js